/* import __COLOCATED_TEMPLATE__ from './receipt-title.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();